export const AGENDA_LIST_GENERIC_ACTIVITY_LIST_SORT = 'AGENDA_LIST_GENERIC_ACTIVITY_LIST_SORT';

export const AGENDA_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE = 'AGENDA_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE';
